import { formatDateKey, extractDate } from '../../utils/dateTimeUtils';
import { min, max, addDays, startOfDay } from 'date-fns';
angular.module('leanlaw').controller('TimePlannerCtrl', ['$scope', '$rootScope', '$window', '$timeout', '$state', 'userService', 'leanLawApi', 'timerManager', 'ModalService', 'tracking', 'alerts', function ($scope, $rootScope, $window, $timeout, $state, userService, leanLawApi, timerManager, ModalService, tracking, alerts) {
  let defaultHour;
  let useDateHandling = false; // Feature flag for localDateTime format (Story #41530)
  // Vertical resolution of 0.1h
  $scope.defaultResolution = 10;
  $scope.resolution = 10;
  $scope.extraWidth = 0; // How many extra pixels to give days
  $scope.selectedDate = new Date();
  $scope.days = [];
  $scope.domain = leanLawApi.domain;
  $scope.tasks = [];
  $scope.tasksLoaded = false;
  $scope.entriesByDay = {}; // Batch-fetched entries grouped by date key
  $scope.entriesLoading = false; // Flag to prevent duplicate fetches

  // Used by update function and is set to true after first run
  // Currently used to detect when to call scrollToMorning()
  let hasFirstUpdateBeenPerformed = false;
  const entryWidth = 250;
  const entryHeaderHeight = 59; // This is the header on each dayBlock

  const planner = document.getElementById('planner-content');
  const sidebar = document.getElementById('planner-sidebar');
  const timebar = document.querySelector('.planner-content div[time-bar]');
  let plannerBoundingRect = planner.getBoundingClientRect();

  // List of all .hover-indicator elements in document
  // Updated in updateDays
  let hoverIndicators = [];

  // Stored cursor position for when the user scrolls
  let mouseY = 0;
  userService.me().then(me => {
    $scope.integration = me.company.integration;
    $scope.account = me;
    $scope.me = me;
    $scope.plannerAccount = {
      id: me.id
    };
    $scope.enableNewTimeEntry = (me.features?.timeEntriesTab ?? false) && (me.settings?.enableNewTimeEntry ?? false);
    useDateHandling = me.features?.dateHandling ?? false;
    if (me.settings.plannerAccount) {
      $scope.plannerAccount = {
        id: me.settings.plannerAccount.id
      };
    }
    defaultHour = me.company.settings.timeEntryIncrement || 0.1;
    $scope.isLoading = false;
    leanLawApi.listTasks().then(tasks => {
      if (tasks && tasks.tasks && Array.isArray(tasks.tasks)) {
        $scope.tasks = tasks.tasks;
        // Add name and type properties for compatibility
        for (let i = 0; i < $scope.tasks.length; i++) {
          const t = $scope.tasks[i];
          t.name = t.label;
          t.type = 'Task';
        }
        $scope.tasksLoaded = true;
      }
    }).catch(error => {
      console.warn('Failed to load tasks for snippet functionality:', error);
      $scope.tasks = [];
      $scope.tasksLoaded = true; // Still mark as loaded to prevent blocking
    });
  });

  // Tutorial (drag to create entries) modal
  const showTutorialModal = function () {
    return ModalService.showModal({
      template: require('./views/tutorialModal.html'),
      bodyClass: 'show-modal-overlay',
      controller: 'tutorialModalController'
    });
  };

  // Returns width of planner
  const getPlannerWidth = function () {
    // Subtract width of sidebar
    return planner.scrollWidth - timebar.clientWidth - sidebar.offsetWidth;
  };
  const resizeSidebar = function () {
    // Resize sidebar (subtract extra for padding)
    sidebar.style.height = `${planner.clientHeight}px`;
    timebar.style.left = `${sidebar.offsetWidth}px`; // inc. scrollbar
  };

  // Scroll to current hour
  const scrollToMorning = function () {
    // Scroll to just before the current hours
    const currentHour = new Date().getHours();
    // Calculate corresponding hour position in px, clamped at 00:00
    planner.scrollTop = $scope.resolution * 10 * Math.max(currentHour - 3, 0);
  };
  const getTimeString = function (mouseY) {
    // Subtract 59px for the height/offset created by the headers
    let relHoursPosition = mouseY - entryHeaderHeight;
    const interval = $scope.resolution * defaultHour * 10;
    const snap = Math.round(relHoursPosition / interval) * interval;
    relHoursPosition = snap;

    // The height of an hour in pixels
    // Remember that resolution is the height of one 6-min interval
    const hourHeight = $scope.resolution * 10;

    // Calculate the time string corresponding to this time
    let numHours = Math.floor(relHoursPosition / hourHeight);
    let numMinutes = Math.floor(relHoursPosition % hourHeight / hourHeight * 60);
    const meridian = numHours >= 12 ? 'PM' : 'AM';

    // Pad minutes
    numMinutes = numMinutes < 10 ? `0${numMinutes}` : numMinutes;

    // People seem to like 12 hr time for some reason
    numHours = numHours === 0 ? 12 : numHours;
    numHours = numHours > 12 ? numHours - 12 : numHours;
    return `${numHours}:${numMinutes} ${meridian}`;
  };
  const updateHoverIndicator = event => {
    // Set known mouse y for fake event later
    mouseY = event.pageY;
    let relPosition = event.pageY - plannerBoundingRect.top + planner.scrollTop;

    // Don't allow the hover indicator to go into the negatives
    if (relPosition - entryHeaderHeight <= 0) relPosition = entryHeaderHeight;
    const timeString = getTimeString(relPosition);

    // Apply position after transforming it
    const top = `${relPosition}px`;
    if (hoverIndicators) {
      // can't use forEach on hoverIndicators in EDGE
      // https://stackoverflow.com/questions/46929157/foreach-on-queryselectorall-not-working-in-recent-microsoft-browsers
      for (let i = 0; i < hoverIndicators.length; i++) {
        const hoverIndicator = hoverIndicators[i];
        hoverIndicator.style.top = top;
        hoverIndicator.querySelector('.hover-time span.time-field').textContent = timeString;
      }
    }
  };

  // Add event listeners for hover
  planner.addEventListener('mousemove', updateHoverIndicator);

  // Add event listener for scroll
  // (makes it look fancy/lets users use scroll wheel to define time)
  planner.addEventListener('scroll', event => {
    // HACK: Trigger handler with fake mouse move event object
    updateHoverIndicator({
      pageY: mouseY
    });
  });
  userService.list().then(accounts => {
    $scope.accounts = accounts;
  });
  $scope.timerManager = timerManager;
  $scope.startTimer = function startTimer() {
    const timer = timerManager.createTimer({
      start: true
    });
  };

  // Timer cleanup functionality
  $scope.getTimerCleanupTooltip = function () {
    const timerCount = $scope.timerManager.timers.length;
    if (timerCount > 50) {
      return `You have ${timerCount} timers pending. Click here to clean up your old timers and improve performance on this page.`;
    }
    return 'Click here to clean up old timers';
  };
  $scope.openTimerCleanupModal = function () {
    // Track modal opening event
    tracking.event('Timer cleanup opened', 'Modal', {
      email: $scope.me.email,
      name: $scope.me.name,
      role: $scope.me.role,
      created_at: $scope.me.created_at,
      registrant: $scope.me.registrant,
      impersonation: $scope.me.impersonation,
      companyName: $scope.me.company?.name,
      companyStatus: $scope.me.company?.status,
      timerCount: $scope.timerManager.timers.length
    });

    // Capture references for the modal
    const parentMe = $scope.me;
    const parentTimerManager = $scope.timerManager;
    ModalService.showModal({
      template: `
          <div class="modal timer-cleanup-modal" style="display: block;">
            <div class="modal-dialog" style="width: 500px; margin: 50px auto;">
              <div class="modal-content">
                <div class="modal-header" style="padding: 16px 20px; border-bottom: none; position: relative; border-radius: 4px 4px 0 0;">
                  <button type="button" class="close" ng-click="close()" style="position: absolute; right: 15px; top: 12px; color: #333; opacity: 0.6; font-size: 21px; font-weight: bold; background: none; border: none; cursor: pointer;">&times;</button>
                  <h4 style="margin: 0; font-size: 24px; font-weight: 400; text-align: center; color: #333;">Timer Cleanup</h4>
                </div>
                <div style="height: 4px; background-color: #4CAF50; margin: 0;"></div>
                <div class="modal-body" style="padding: 20px;">
                  <div style="margin-bottom: 20px;">
                    <label style="display: inline-block; margin-right: 10px;">Delete timers older than:</label>
                    <input type="number" ng-model="daysOld" min="1" max="365" 
                           ng-change="onDaysOldChange()"
                           style="width: 70px; text-align: center; padding: 5px; border: 1px solid #ccc; border-radius: 3px;"> 
                    <span style="margin-left: 5px;">days</span>
                  </div>
                  <div style="margin-bottom: 15px; padding: 10px; background-color: #f9f9f9; border-radius: 3px; font-size: 13px; color: #666;">
                    This will permanently delete timers with start times further back in time than the specified number of days ago. This action cannot be undone.
                  </div>
                  <div ng-if="oldTimers.length > 0" style="padding: 10px; background-color: #fcf8e3; border: 1px solid #faebcc; border-radius: 3px; color: #8a6d3b; margin-bottom: 10px;">
                    <strong>{{oldTimers.length}}</strong> timer(s) will be deleted.
                  </div>
                  <div ng-if="oldTimers.length === 0 && daysOld" style="padding: 10px; background-color: #dcfce7; border: 1px solid #bbf7d0; border-radius: 3px; color: #166534; margin-bottom: 10px;">
                    No timers found that are older than {{daysOld}} days.
                  </div>
                </div>
                <div class="modal-footer" style="text-align: right; padding: 15px 20px; border-top: 1px solid #e5e5e5;">
                  <button type="button" class="btn btn-default" ng-click="close()" style="margin-right: 10px;">Cancel</button>
                  <button type="button" 
                          class="btn btn-danger" 
                          ng-click="deleteOldTimers()" 
                          ng-disabled="oldTimers.length === 0 || isDeleting || !daysOld || daysOld < 1">
                    <span ng-if="!isDeleting">Delete {{oldTimers.length}} Timer(s)</span>
                    <span ng-if="isDeleting">Deleting...</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        `,
      controller: ['$scope', 'close', function ($scope, close) {
        $scope.daysOld = 7; // Default to 7 days
        $scope.oldTimers = [];
        $scope.isDeleting = false;
        $scope.close = close;

        // Handle changes in daysOld input
        $scope.onDaysOldChange = function () {
          if ($scope.daysOld && $scope.daysOld > 0 && Number.isInteger(Number($scope.daysOld))) {
            $scope.updateOldTimersList();
          } else {
            // Clear the list if invalid input
            $scope.oldTimers = [];
          }
        };
        $scope.updateOldTimersList = function () {
          const cutoffDate = new Date();
          cutoffDate.setDate(cutoffDate.getDate() - $scope.daysOld);
          $scope.oldTimers = parentTimerManager.timers.filter(function (timer) {
            if (!timer.startTime) {
              return false;
            }

            // The API refuses to delete a running timer however old it is -- there is no
            // limit on how long one may run, so age is not evidence it is finished. Leaving
            // it in this list would delete it from the view but not the server, and it would
            // reappear on the next load.
            if (timer.timing) {
              return false;
            }
            let timerCreated;

            // This should match what the backend uses for FirstStarted
            if (timer.startTime instanceof Date) {
              timerCreated = timer.startTime;
            } else {
              timerCreated = new Date(timer.startTime);
            }

            // Check if the date is valid
            if (isNaN(timerCreated.getTime())) {
              return false;
            }

            // Compare dates
            return timerCreated <= cutoffDate;
          });
        };
        $scope.deleteOldTimers = function () {
          // Safety checks
          if ($scope.oldTimers.length === 0) return;
          if (!$scope.daysOld || $scope.daysOld < 1 || !Number.isInteger(Number($scope.daysOld))) {
            if (window.bootbox) {
              bootbox.alert('Please enter a valid number of days (1 or greater).');
            } else {
              alert('Please enter a valid number of days (1 or greater).');
            }
            return;
          }
          $scope.isDeleting = true;

          // Capture original timer count before deletion starts
          const originalTimerCount = parentTimerManager.timers.length;
          const timersToDelete = [...$scope.oldTimers];

          // Calculate the cutoff date in local time
          const cutoffDate = new Date();
          cutoffDate.setDate(cutoffDate.getDate() - $scope.daysOld);

          // Send local time - backend will handle timezone offset via timeOffset parameter
          leanLawApi.bulkDeleteTimers({
            deleteOlderThan: cutoffDate.toISOString()
          }).then(function (result) {
            // Remove deleted timers from the timer manager
            // Since we're using date-based deletion, we need to remove the timers that match our criteria
            // ?? not ||: the server returning 0 is an answer, and reporting the number
            // we asked to delete instead would claim deletions that did not happen.
            const deletedCount = result.deletedCount ?? timersToDelete.length;
            timersToDelete.forEach(function (timer) {
              const index = parentTimerManager.timers.indexOf(timer);
              if (index !== -1) {
                parentTimerManager.timers.splice(index, 1);
              }
            });

            // Track timer cleanup execution event
            tracking.event('Timer cleanup executed', 'Action', {
              email: parentMe.email,
              name: parentMe.name,
              role: parentMe.role,
              created_at: parentMe.created_at,
              registrant: parentMe.registrant,
              impersonation: parentMe.impersonation,
              companyName: parentMe.company?.name,
              companyStatus: parentMe.company?.status,
              daysOld: $scope.daysOld,
              timersDeleted: deletedCount,
              totalTimers: originalTimerCount,
              errors: 0,
              bulkDelete: true,
              deleteMethod: 'date-based',
              // Flag to indicate new method
              cutoffDate: cutoffDate.toISOString()
            });
            $scope.close();

            // Show success notification using the product's standard alerts system
            const timerText = deletedCount === 1 ? 'timer' : 'timers';
            alerts.success(`Successfully deleted ${deletedCount} ${timerText}.`);
          }).catch(function (error) {
            $scope.isDeleting = false;

            // Track error in cleanup event
            tracking.event('Timer cleanup executed', 'Action', {
              email: parentMe.email,
              name: parentMe.name,
              role: parentMe.role,
              created_at: parentMe.created_at,
              registrant: parentMe.registrant,
              impersonation: parentMe.impersonation,
              companyName: parentMe.company?.name,
              companyStatus: parentMe.company?.status,
              daysOld: $scope.daysOld,
              timersDeleted: 0,
              totalTimers: originalTimerCount,
              errors: 1,
              bulkDelete: true,
              deleteMethod: 'date-based',
              errorMessage: error.body || error.message || 'Unknown error',
              cutoffDate: cutoffDate.toISOString()
            });
            if (window.bootbox) {
              bootbox.alert('An error occurred while deleting timers. Please try again.');
            } else {
              alert('An error occurred while deleting timers. Please try again.');
            }
          });
        };

        // Initialize the list
        $scope.updateOldTimersList();
      }]
    });
  };

  /* loader*/
  $scope.isLoading = true;

  // Default value
  $scope.singleDayView = true;
  if (window.localStorage) {
    const {
      localStorage
    } = window;

    // Check if localStorage contains singleDayView key
    if (localStorage.getItem('singleDayView') === null) {
      // Set default value
      localStorage.setItem('singleDayView', $scope.singleDayView);
    } else {
      // Load persistent value from local storage
      // The storage type is string, so it must be cast to bool
      $scope.singleDayView = localStorage.getItem('singleDayView') == 'true';
    }
  }

  // Batch fetch entries for all visible days in a single API call
  // This resolves the N+1 API calls performance issue
  const loadEntriesForDateRange = function (days, account) {
    if (!days || days.length === 0) return;

    // Reset state to prevent stale data and race conditions when switching accounts
    $scope.entriesByDay = {};
    $scope.entriesLoading = true;

    // Find the min and max dates from the days array using date-fns
    const startDate = startOfDay(min(days)).toNetworkDate();
    const endDate = startOfDay(addDays(max(days), 1)).toNetworkDate();
    const params = {
      startDate,
      endDate,
      billed: 'any'
    };

    // Only include account if it exists
    if (account && account.id) {
      params.account = account.id;
    }
    leanLawApi.listEntries(params).then(({
      entries,
      summary
    }) => {
      const groupedEntries = {};

      // Convert startTime/endTime to Date objects
      // remove after dateHandling is fully rolled out
      entries.forEach(e => {
        e.startTime = new Date(e.startTime);
        e.date = new Date(e.startTime);
        e.endTime = new Date(e.endTime);
      });
      // Initialize empty arrays for all visible days
      days.forEach(day => {
        const key = formatDateKey(day);
        groupedEntries[key] = {
          entries: [],
          summary: {
            billableHours: 0,
            nonBillableHours: 0,
            fixedFeeHours: 0
          }
        };
      });

      // Distribute entries into their respective day buckets
      entries.forEach(entry => {
        // Extract date: localDateTime.date (new) or startTime (legacy) based on feature flag
        const key = useDateHandling && entry.localDateTime?.date ? entry.localDateTime.date : extractDate(entry.startTime);
        if (groupedEntries[key]) {
          groupedEntries[key].entries.push(entry);
          // Calculate summary per day
          if (entry.billingType === 'billable') {
            groupedEntries[key].summary.billableHours += entry.hours || 0;
          } else if (entry.billingType === 'fixedFee') {
            groupedEntries[key].summary.fixedFeeHours += entry.hours || 0;
          } else {
            groupedEntries[key].summary.nonBillableHours += entry.hours || 0;
          }
        }
      });
      $scope.entriesByDay = groupedEntries;
      $scope.entriesLoading = false;

      // Broadcast to dayBlock directives that entries are ready
      $scope.$broadcast('entriesLoaded');
    }).catch(err => {
      console.error('Could not load entries for date range:', err);
      $scope.entriesLoading = false;
      // Broadcast with empty data so dayBlocks can render
      $scope.$broadcast('entriesLoaded');
    });
  };

  // Updates the day row instances and their widths
  // This is called every time the page is resized or
  // $scope.selectedDate is changed
  const updateDays = function (refresh) {
    // Number of days to render
    let numDays = 1; // Default for single day view

    // Toggle to render multi-day view for multi-day view
    if (!$scope.singleDayView) numDays = Math.floor(getPlannerWidth() / entryWidth);

    // Clamp to beginning of month
    if ($scope.selectedDate.getDate() < numDays) $scope.selectedDate.setDate(numDays);
    if (refresh) $scope.days = [];

    // Don't recreate all of the days repeatedly, only add new days
    // The exception is if the refresh param is true
    if (!refresh && $scope.days.length > numDays) {
      // Remove extras in-place
      // Array.splice caused flicker in the calendar
      const numExtras = $scope.days.length - numDays;
      for (var i = 0; i < numExtras; i++) {
        $scope.days.pop();
      }
    } else if ($scope.days.length < numDays) {
      // Add extras/fill in days
      for (var i = $scope.days.length; i < numDays; i++) {
        // Create a day to be modified:
        const day = new Date($scope.selectedDate);
        day.setDate($scope.selectedDate.getDate() - i);
        $scope.days.push(day);
      }
    }

    // Determine how much extra width to give each day
    $scope.extraWidth = (getPlannerWidth() - entryWidth * $scope.days.length) / $scope.days.length;

    // Update bounding rect occasionally
    plannerBoundingRect = planner.getBoundingClientRect();

    // Resizes sidebar occasionally
    resizeSidebar();

    // Refresh hover indicators list on next cycle
    $timeout(() => {
      hoverIndicators = document.querySelectorAll('.hover-indicator');
    });

    // Batch fetch entries for all visible days (fixes N+1 API calls issue)
    if ($scope.days.length > 0 && $scope.plannerAccount) {
      loadEntriesForDateRange($scope.days, $scope.plannerAccount);
    }

    // Check if this is the first time this function was called
    if (!hasFirstUpdateBeenPerformed) {
      hasFirstUpdateBeenPerformed = true;

      // Scroll to morning on next cycle
      $timeout(scrollToMorning, 0);
    }
  };

  // Watch for exit from .edit state
  $rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState) => {
    resizeViewport();
    // Verify that this is a navigation regarding substates
    if (fromState.name.indexOf('timeplanner.') === -1) return;

    // Do full refresh to reflect changes
    updateDays(true);
  });

  // Make sure window is always below the header, even after media queries are applied
  const resizeViewport = function resizeViewport() {
    resizeSidebar();
    const h = $('.ts.header').height();
    $('.timeplanner .planner-content').css({
      top: `${h}px`
    });
    $('.timeplanner .day-header').css({
      top: `${h}px`
    });
  };

  // Watch for page resizes and adjust visible content accordingly
  angular.element($window).bind('resize', event => {
    // Don't perform a full refresh of days
    $scope.$apply(() => {
      updateDays();
    });
    resizeViewport();
    $scope.$digest();
  });
  function daysInMonth(year, month) {
    return new Date(year, month, 0).getDate();
  }

  // Handles user clicking on the small calendar
  $scope.handleDayChange = function (newDate) {
    // User click should indicate beginning of the day view
    // This means that we need to convert the selected day to the
    // latest possible day
    let targetDay = newDate.getDate();

    // Add number of days visible in planner
    targetDay += $scope.days.length - 1;

    // Clamp to end of month
    const maxDate = daysInMonth(newDate.getFullYear(), newDate.getMonth() + 1);
    if (targetDay > maxDate) targetDay = maxDate;
    newDate.setDate(targetDay);
    $scope.selectedDate = new Date(newDate);

    // Update the rendered days and force a full refresh
    updateDays(true);
  };

  // Operators can change the planner account
  // Note: State reset (entriesByDay, entriesLoading) happens in loadEntriesForDateRange
  $scope.changeAccount = function () {
    updateDays(true);
  };

  // Used to update view once all data is populated
  $scope.$watch('isLoading', newValue => {
    // Only respond when loading stops
    if (newValue) return;
    resizeViewport();
    scrollToMorning();
    $timeout(() => {
      updateDays(true);
    });
  });

  // Updates the scroll position based on the new planner scale
  const updateScrollScale = function (newScaleRatio) {
    // Translate -> Scale -> -Translate

    const translateAmount = planner.clientHeight * newScaleRatio / 2.0;
    // translateAmount *= newScaleRatio;

    let st = planner.scrollTop;
    // Perform transform in the middle of the planner's viewport
    st += translateAmount;
    // Adjust scroll position by ratio change
    st *= newScaleRatio;
    st -= translateAmount;
    planner.scrollTop = st;
  };

  // Decrease resolution down to 10px
  $scope.decreaseScale = function () {
    const oldResolution = $scope.resolution;
    const newResolution = Math.max($scope.resolution - 5, 5);
    $scope.resolution = newResolution;
    updateScrollScale(newResolution / oldResolution);
    updateDays();
  };

  // Increase resolution up to 30px
  $scope.increaseScale = function () {
    const oldResolution = $scope.resolution;
    const newResolution = Math.min($scope.resolution + 5, 30);
    $scope.resolution = newResolution;
    updateScrollScale(newResolution / oldResolution);
    updateDays();
  };

  // Set whether or not the planner is in a single-day view
  $scope.setSingleDayView = function (enabled) {
    // This function reloads days, so don't let it run extraneously
    if ($scope.singleDayView === enabled) return;

    // Store value for future sessions
    if (window.localStorage) {
      const {
        localStorage
      } = window;
      localStorage.setItem('singleDayView', enabled);
    }
    $scope.singleDayView = enabled;
    updateDays(true);
  };

  // Generates the string that represents the current month
  $scope.getMonthString = function () {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    // Build string
    let s = months[$scope.selectedDate.getMonth()];
    s += ` ${$scope.selectedDate.getFullYear()}`;
    return s;
  };

  // Returns true if the selected month is the same as today's month
  $scope.getIsCurrentMonth = function () {
    const today = new Date();
    const selected = $scope.selectedDate;
    return today.getMonth() === selected.getMonth() && today.getFullYear() === selected.getFullYear();
  };

  // Back arrow
  $scope.changeMonth = function (delta) {
    const newSelectedDate = new Date($scope.selectedDate);
    newSelectedDate.setFullYear($scope.selectedDate.getFullYear());
    newSelectedDate.setMonth($scope.selectedDate.getMonth() + delta);
    // Set the selected date to the number of days visible
    newSelectedDate.setDate($scope.days.length);
    $scope.selectedDate = newSelectedDate;
    updateDays(true);
  };
  // Back arrow
  $scope.goBackMonth = function () {
    $scope.changeMonth(-1);
  };
  // Forward arrow
  $scope.goForwardMonth = function () {
    $scope.changeMonth(+1);
  };
  setInterval(resizeViewport, 500);
  $scope.addTaskEntry = function (task) {
    // Determine description based on settings
    let description = task.name || task.label;
    const codesSettings = $scope.me?.company?.settings?.codes || {};

    // Only set initial description if populateDescriptions is enabled
    // populateDescriptionsPlus will be handled in the modal when both codes are selected
    if (!codesSettings.populateDescriptions) {
      description = '';
    }
    if ($scope.enableNewTimeEntry) {
      $state.go('timeplanner.new2', {
        entry: {
          startTime: $scope.selectedDate,
          hours: defaultHour,
          description: description,
          account: $scope.plannerAccount
        },
        item: {
          id: task.id,
          type: task.type
        }
      });
    } else {
      // Use the traditional state navigation approach
      const showExpanded = !$scope.singleDayView;
      $state.go('timeplanner.new', {
        entry: {
          startTime: $scope.selectedDate,
          hours: defaultHour,
          description: description,
          account: $scope.plannerAccount
        },
        item: {
          id: task.id,
          type: task.type
        },
        expanded: showExpanded
      });
    }
  };
}]);